
import React from 'react';

const AutomatedDecisionMaking = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">X. No automated decision-making (including profiling)</h3>
      <p className="text-gray-600">
        We do not intend to use personal data collected from you for any automated decision-making process (including profiling).
      </p>
    </div>
  );
};

export default AutomatedDecisionMaking;
